export const STATUT_LABELS = {
  A_RELANCER: "À relancer",
  RELANCE_1: "Relance 1",
  RELANCE_2: "Relance 2",
  ATTENTE_COMPTA: "En attente de réponse de la compta",
  PROMESSE_PAIEMENT: "Promesse de paiement",
  EN_LITIGE: "En litige",
  SOLDE: "Soldé",
};

export const labelFor = (labels, key) => labels[key] || key || "—";

export const euros = (centimes) =>
  centimes != null ? (centimes / 100).toFixed(2).replace(".", ",") + " €" : "—";

export const retardBadgeVariant = (jours) => {
  if (jours <= 30) return "warning";
  if (jours <= 60) return "danger";
  return "dark";
};
